import Axios from "../../services/axios-service";

const applyPromoCode = async (couponCode) => {
  return await Axios.get(
    "/api/applypromooffer/" + couponCode,
    undefined,
    undefined
  );
};

const placeOrder = async (objOrder) => {
  return await Axios.post("/api/submitorder", objOrder, undefined);
};

const createPaymentIntent = async (payload) => {
  return await Axios.post("/api/create-payment-intent", payload, undefined);
};

const updatePaymentIntent = async (payload) => {
  return await Axios.post("/api/update-payment-intent", payload, undefined);
};

const submitOrder = async (payload) => {
  return await Axios.post("/api/submitorderForB2C", payload, undefined);
};

const validateTravellerEmail = async (email) => {
  return await Axios.get(
    "/api/TravelerExists?email=" + encodeURIComponent(email),
    undefined,
    undefined
  );
};

const getTravellerInfo = async (userId) => {
  return Axios.get("/api/travelerbasicinfo/" + userId, undefined, undefined);
};

const getProductPricingAndInfo = async () => {
  return await Axios.get("/api/completeproductinfo", undefined, undefined);
};

const getAllCountries = async () => {
  return Axios.get("/api/Country", undefined, undefined);
};

const getCountryListDetail = async () => {
  return await Axios.get("/api/GetCountryListDetail", undefined, undefined);
};

const getCompleteProductInfoDetail = async () => {
  return await Axios.get("/api/completeproductinfoDetail", undefined, undefined);
};

const getOrderSummaryPricing = async (data) => {
  return await Axios.post("/api/getPricing/orderSummary", data, undefined);
};

const calculatePricing = async (data) => {
  return await Axios.post("/api/calculatePricing", data, undefined);
};

const convertCurrency = async () => {
  return await Axios.get("/api/GetCurrencyValue/CAD", undefined, "NO_TOKEN");
};

const createOrderPaypal = (orderInfoDev) => {
  return Axios.post("/api/Paypal/CreateOrder", orderInfoDev).then(
    (response) => {
      console.log(response.data);
      return response.data.orderId;
    }
  );
};

const captureOrder = (orderId, orderInfoDev) => {
  return Axios.post(`/api/Paypal/${orderId}/CaptureOrder`, orderInfoDev);
};

const getGendersList = () => {
  return Axios.get("/api/GetGendersList", undefined, undefined);
};

//md5 Email Exit
const EmployeeExits = async (email) => {
  return await Axios.get(
    "/api/EmployeeExits?email=" + encodeURIComponent(email),
    undefined,
    undefined
  );
};

//md5 Check Employee Child Exit
const CheckEmployeeChild = async (email) => {
  return await Axios.get(
    "/api/CheckEmployeeChild?email=" + encodeURIComponent(email),
    undefined,
    undefined
  );
};

const EmployeeSubmitOrder = async (objOrder) => {
  return await Axios.post("/api/EmployeeSubmitOrder", objOrder, undefined);
};

const EmployeePaypalCreateOrder = (orderInfoDev) => {
  return Axios.post("/api/EmployeePaypalCreateOrder", orderInfoDev).then(
    (response) => {
      return response.data.orderId;
    }
  );
};

const EmployeePaypalCaptureOrder = (orderId, orderInfoDev) => {
  return Axios.post(`/api/EmployeePaypalCaptureOrder`, orderInfoDev);
};

const autoCompleteAddress = async (inputAddress) => {
  return await Axios.get(
    "/api/autoCompleteAddress?inputAddress=" + encodeURIComponent(inputAddress),
    undefined,
    undefined
  );
};



export default {
  applyPromoCode,
  placeOrder,
  validateTravellerEmail,
  getTravellerInfo,
  getProductPricingAndInfo,
  getAllCountries,
  getOrderSummaryPricing,
  calculatePricing,
  convertCurrency,
  createOrderPaypal,
  captureOrder,
  getGendersList,
  EmployeeExits,
  CheckEmployeeChild,
  EmployeeSubmitOrder,
  EmployeePaypalCreateOrder,
  EmployeePaypalCaptureOrder,
  createPaymentIntent,
  updatePaymentIntent,
  submitOrder,
  autoCompleteAddress,
  getCountryListDetail,
  getCompleteProductInfoDetail
};
